import {
  TAGS_URL
} from 'app/utils/Constants';

import {
  post
} from 'app/services/ApiService';

export const getTags = async params => {
  return await post(TAGS_URL(), params);
}
